import { render, staticRenderFns } from "./Sollecito.vue?vue&type=template&id=01166d62&"
import script from "./Sollecito.vue?vue&type=script&lang=js&"
export * from "./Sollecito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports